import { i18n } from 'i18next';
import { Table } from 'pdfmake/interfaces';
import { Registration } from '../types/registrationTypes';
import { tableRow } from './tableRow';

export const deviceAndSystemHeader = (t: i18n['t']): Table['body'] => {
  return [
    [
      {
        style: 'tableHeader',
        margin: [10, 0, 0, 0],
        text: t('registrations.general.device', { context: 'plural' })
      },
      {},
      {
        style: 'tableHeader',
        margin: [0, 0, 0, 0],
        text: t('registrations.general.system')
      }
    ]
  ];
};

export const deviceAndSystemData = (t: i18n['t'], registration: Registration): Table['body'] => {
  const MISSING_DATA_STRING = 'MISSING DATA';
  const INVALID_DEVICE_STRING = 'invalidDevice';
  return [
    [
      {
        style: 'tableBody',
        margin: [10, 5, 10, 10],
        columns: [
          [
            tableRow(t('registrations.general.serialNumber'), t('registrations.general.device'), true),
            ...(registration?.devices?.items ?? []).map((device) => {
              return {
                columns: [
                  tableRow(
                    device.serialNumber === MISSING_DATA_STRING || device.serialNumber === INVALID_DEVICE_STRING ? '-' : device.serialNumber ?? '',
                    device.articleName === MISSING_DATA_STRING || device.articleName === INVALID_DEVICE_STRING ? '-' : device.articleName ?? '',
                    false,
                    false
                  )
                ]
              };
            })
          ]
        ]
      },
      {},
      {
        style: 'tableBody',
        margin: [0, 5, 10, 10],
        columns: [
          [
            tableRow(t('registrations.general.installation'), t(`registrations.general.${registration.heatingSetup?.installationType}` ?? '')),
            tableRow(
              t('registrations.general.heatSource'),
              (registration.heatingSetup?.heatSource ?? []).map((hs) => t(`registrations.general.${hs}`)).join('\n')
            ),
            tableRow(
              t('registrations.general.heatSystem'),
              (registration.heatingSetup?.heatSystem ?? []).map((hs) => t(`registrations.general.${hs}`)).join('\n')
            ),
            tableRow(t('registrations.general.coolant'), t(`registrations.general.${registration.heatingSetup?.coolant}` ?? '')),
            registration.heatingSetup?.comment ? tableRow(t('registrations.general.comment'), t(`${registration.heatingSetup?.comment}`)) : ''
          ]
        ]
      }
    ]
  ];
};
